import { SearchIcon } from '@/styles/Icon'
import { type ChangeEvent } from 'react'
interface SearchInputProps {
  placeholder?: string
  className?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  value?: string
}
export const SearchInput = ({
  placeholder,
  className,
  onChange,
  value,
}: SearchInputProps) => {
  return (
    <div className={`flex w-full items-center ${className}`}>
      <input
        placeholder={placeholder}
        className='!h-12 w-full min-w-[360px] max-w-[calc(100%-48px)] rounded-s-[6px] px-2 font-normal text-dark-400 outline-none transition placeholder:text-dark-400/80 hover:cursor-pointer hover:border-primary-dark focus:border-primary-dark'
        onChange={onChange}
        value={value}
      />
      <SearchIcon />
    </div>
  )
}
